<template>
  <div class="lyf-ui-action-icon" @click="iconClick($event)">
    <lyf-icon :icon="icon" :size="20" :color="color"></lyf-icon>
    <div class="lyf-ui-action-icon-text" :style="{
      color
    }">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'LyfActionBarIcon',
  props: {
    icon: String,
    color: String,
    text: String,
  },
  emits: ['click'],
  methods: {
    iconClick(e) {
      this.$emit('click', e)
    }
  }
}
</script>

<style scoped>
.lyf-ui-action-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: var(--space_16);
  color: var(--N1_3);
}
.lyf-ui-action-icon  .lyf-ui-action-icon-text {
  margin-top: 2px;
  font-size: 10px;
}
</style>